export default __webpack_public_path__ + "static/media/MerilynLovelace.2557dd84.png";